// Show notification animation
const showCopyNotification = () => {
	let time = 0;
	const elem = document.getElementById( 'coca_bais_copy_html' );
	if ( ! elem ) return;

	elem.style.display = 'block';

	const copyAlert = function() {
		if ( time === 200 ) {
			window.clearInterval( id );
			elem.style.transform = 'translateX(200%)';
			elem.style.opacity = '0';
		} else {
			time++;
			elem.style.transform = 'translateX(0%)';
			elem.style.opacity = '1';
		}
	};

	const id = window.setInterval( copyAlert, 10 );
};

// coca_do_copy_the_shortcode - for input fields (.coca_bais_slider_shortcode)
const cocaDoCopyTheShortcode = ( event ) => {
	const copyText = event.target;

	if ( copyText.value !== '' ) {
		copyText.focus();
		copyText.select();
		copyText.setSelectionRange( 0, 99999 );
		document.execCommand( 'copy' );
		showCopyNotification();
	}
};

// Copy shortcode from button data attribute (.copy-shortcode and .copy-shortcode-text)
const cocaDoCopyFromButton = ( event ) => {
	event.preventDefault();
	const element = event.target.closest( '.copy-shortcode' ) || event.target.closest( '.copy-shortcode-text' );
	if ( ! element ) return;

	const shortcode = element.getAttribute( 'data-shortcode' );
	if ( ! shortcode ) return;

	// Use modern clipboard API with fallback
	if ( navigator.clipboard && navigator.clipboard.writeText ) {
		navigator.clipboard.writeText( shortcode ).then( () => {
			showCopyNotification();
		} ).catch( () => {
			// Fallback to execCommand
			fallbackCopyText( shortcode );
		} );
	} else {
		fallbackCopyText( shortcode );
	}
};

// Fallback copy method for older browsers
const fallbackCopyText = ( text ) => {
	const textArea = document.createElement( 'textarea' );
	textArea.value = text;
	textArea.style.position = 'fixed';
	textArea.style.left = '-999999px';
	textArea.style.top = '-999999px';
	document.body.appendChild( textArea );
	textArea.focus();
	textArea.select();
	document.execCommand( 'copy' );
	textArea.remove();
	showCopyNotification();
};

// Fire copy for input fields (All Sliders page)
if ( !! document.querySelectorAll( '.coca_bais_slider_shortcode' ).length ) {
	[].map.call(
		document.querySelectorAll( '.coca_bais_slider_shortcode' ),
		( shortcode ) => {
			shortcode.addEventListener( 'click', cocaDoCopyTheShortcode );
		}
	);
}

// Fire copy for buttons (Carousel page and row actions)
if ( !! document.querySelectorAll( '.copy-shortcode' ).length ) {
	[].map.call(
		document.querySelectorAll( '.copy-shortcode' ),
		( button ) => {
			button.addEventListener( 'click', cocaDoCopyFromButton );
		}
	);
}

// Fire copy for shortcode text elements (clickable shortcode text)
if ( !! document.querySelectorAll( '.copy-shortcode-text' ).length ) {
	[].map.call(
		document.querySelectorAll( '.copy-shortcode-text' ),
		( textElement ) => {
			textElement.addEventListener( 'click', cocaDoCopyFromButton );
		}
	);
}
